import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HereMapComponent } from './here-map.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [HereMapComponent],
  exports: [HereMapComponent]
})
export class HereMapModule { }



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/here-map/here-map.module.ts